import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';

// Register required chart components in Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, BarElement, CategoryScale, LinearScale,);

const DistributionGraph = () => {
    const circumference = 260; // deg

    const data = {
        labels: ["Mechanical", "Electrical", "Landscape", "Smart"],
        datasets: [
            {
                label: "Project Progress",
                data: [124, 26, 36, 46],
                backgroundColor: [
                    "#00858e", // Mechanical
                    "#5fba68", // Electrical
                    "#ff722f", // Landscape
                    "#646668", // Smart
                ],
                borderWidth: 0,
                borderRadius: ({ dataIndex, dataset }) => {
                    const radius = {};
                    if (dataIndex === 0) {
                        radius.innerStart = 50;
                        radius.outerStart = 50;
                    }
                    if (dataIndex === dataset.data.length - 1) {
                        radius.innerEnd = 50;
                        radius.outerEnd = 50;
                    }
                    return radius;
                },
                cutout: "90%",
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        rotation: (circumference / 2) * -1, // Starts at the top
        circumference: circumference, // Sets the circumference of the chart
        cutout: "90%", // Doughnut hole size
        plugins: {
            legend: {
                display: false, // Disable the default legend
            },
            tooltip: {
                enabled: true, // Show tooltips
            },
        },
    };

    // MINI1
    const mini1Data = {
        labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [9, 17, 5, 8],
                backgroundColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(75, 192, 192, 1)',
            },
        ],
    };

    const mini1Options = {
        responsive: true,
        scales: {
            x: {
                display: false, // Hide x-axis grid and labels
                ticks: {
                    font: {
                        size: 5, // Font size for x-axis labels
                    },
                },
            },
            y: {
                display: false, // Hide y-axis grid and labels
                ticks: {
                    font: {
                        size: 5, // Font size for y-axis labels
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                enabled: true, // Enable tooltips on hover
                callbacks: {
                    label: function (tooltipItem) {
                        return `Range: ${tooltipItem.raw}`; // Display the value on hover
                    },
                },
            },
            legend: {
                display: false, // Hide the dataset label
            },
        },
        elements: {
            bar: {
                borderWidth: 0,
                barThickness: 1, // Set the exact width of each bar
                maxBarThickness: 1, // Ensure the bars are not thicker than 1px
                borderRadius: 0, // No border radius
            },
        },
    };
    // MINI2
    const mini2Data = {
        labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [9, 17, 5, 8],
                backgroundColor: '#dc3545',
                borderWidth: 1,
                hoverBackgroundColor: '#dc3545',
            },
        ],
    };

    const mini2Options = {
        responsive: true,
        scales: {
            x: {
                display: false, // Hide x-axis grid and labels
                ticks: {
                    font: {
                        size: 5, // Font size for x-axis labels
                    },
                },
            },
            y: {
                display: false, // Hide y-axis grid and labels
                ticks: {
                    font: {
                        size: 5, // Font size for y-axis labels
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                enabled: true, // Enable tooltips on hover
                callbacks: {
                    label: function (tooltipItem) {
                        return `Range: ${tooltipItem.raw}`; // Display the value on hover
                    },
                },
            },
            legend: {
                display: false, // Hide the dataset label
            },
        },
        elements: {
            bar: {
                borderWidth: 0,
                barThickness: 1, // Set the exact width of each bar
                maxBarThickness: 1, // Ensure the bars are not thicker than 1px
                borderRadius: 0, // No border radius
            },
        },
    };
    return (
        <div className="thirdGraph">
            <div className="box p-2" >
                <h6 className="mt-1 mb-1 title"><b>Distribution</b></h6>
                <div className="halfdoughnut">
                    <Doughnut data={data} options={options} />
                    <div className="curcum">
                        <span id="stup">72%</span>
                        <span>Completed</span>
                    </div>
                </div>
                <div className=" legend-labels">
                    <div className=" label-item">
                        <span className="value" style={{ color: '#00858e' }}>124</span>
                        <span>Mechanical</span>
                    </div>
                    <div className=" label-item">
                        <span className="value" style={{ color: '#5fba68' }}>26</span>
                        <span>Electrical</span>
                    </div>
                    <div className=" label-item">
                        <span className="value" style={{ color: '#ff722f' }} >36</span>
                        <span>Landscape</span>
                    </div>
                    <div className="col label-item">
                        <span className="value" style={{ color: '#646668' }}>46</span>
                        <span>Smart</span>
                    </div>
                </div>
                <div className="data-card mt-1">
                    <div className="row">
                        <div className="col-8">
                            <h6 className="p-0 m-0">Renewable</h6>
                            <p className="value p-0 m-0">91.6K</p>
                            <p className="description p-0 m-0">What is Renewable?</p>
                            <p className="description p-0 m-0">Comparative Analysis</p>
                        </div>
                        <div className="col-4 text-end">
                            <p className="percentage">+32.40%</p>
                            <div className="comparison-chart blue">
                                <Bar data={mini1Data} options={mini1Options} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="data-card mt-1">
                    <div className="row">
                        <div className="col-8">
                            <h6 className="p-0 m-0">Waste</h6>
                            <p className="value p-0 m-0">45.33%</p>
                            <p className="description p-0 m-0">What is Waste?</p>
                            <p className="description p-0 m-0">Comparative Analysis</p>
                        </div>
                        <div className="col-4 text-end">
                            <p className="percentage">+32.40%</p>
                            <div className="comparison-chart red">
                                <Bar data={mini2Data} options={mini2Options} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DistributionGraph;
